<table style="width: 100%">
  <th></th>
  @for (d of data; track d) {
    <tr [style.background-color]="d.changed ?  '#ffa50050' : 'white'">
      <td>{{d.key | removeUnderscore | upperfirst}}</td>
      <td style="white-space: pre-wrap;">{{d.value | json}}</td>
    </tr>
  }
</table>
